__webpack_public_path__=(window['__webpack_public_path__'] + '////assets/plugin-web-record-expends/').replace(/[/]{3,}/g, "/");